import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Slider,
} from "@mui/material";
import { colors } from "../../../theme/theme";

export const EDITOR_SIZE = 400;

export const StyledDialog = styled(Dialog)({
  zIndex: 10000000,
  "& .MuiDialog-paper": {
    borderRadius: "14px",
    padding: 16,
  },
});

export const StyledDialogContent = styled(DialogContent)({
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.primary,
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f4f4f4",
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  fontFamily: "'Quicksand', sans-serif",
  color: colors.primary,
  textAlign: "center",
});

export const StyledDescription = styled(Typography)({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  color: colors.primary,
  marginBottom: 16,
  textAlign: "center",
});

export const ContentWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
});

export const EditorContainer = styled(Box)(({ $editorsize }) => ({
  width: "100%",
  maxWidth: $editorsize,
  height: $editorsize,
  overflow: "hidden",
  borderRadius: "14px",
  border: "1px solid rgba(73, 42, 24, 0.3)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const SliderWrapper = styled(Box)({
  width: "100%",
  maxWidth: 350,
  paddingLeft: 8,
  paddingRight: 8,
});

export const SliderLabel = styled(Typography)({
  fontSize: "12px",
  color: colors.primary,
  marginBottom: 4,
});

export const StyledSlider = styled(Slider)({
  color: colors.primary,
  "& .MuiSlider-thumb": {
    backgroundColor: colors.primary,
  },
});

export const StyledDialogActions = styled(DialogActions)({
  justifyContent: "center",
  gap: 16,
  paddingBottom: 16,
});
